/**
 * Localization module - Used to test the translations of the new/existing keys.
 *
 * Note: Please remove the keys from test-translations.json before merging your PR.
 */

import testTranslations from "./test-translations.json";

const localization = { testTranslations };

export default localization;
